import Layers from "slotworks/graphics/layers/layers";
import { AbstractSpinControl } from "slotworks/smart-ui/controls/spin/abstract-spin-control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import StateMachine from "slotworks/state-machine/state-machine";
import { Keyboard } from "slotworks/utils/keyboard";

export default class SpinControl extends AbstractSpinControl {

    public static SPACE_TO_SKIP: boolean = true;
    public static ENTER_TO_SKIP: boolean = false;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        document.addEventListener("keyup", this.onKeyUpListener);
    }

    public destroy() {
        document.removeEventListener("keyup", this.onKeyUpListener);

        super.destroy();
    }

    public updateOptions(options: ControlOptions) {
        this.options = options;
    }

    protected onButtonPressed() {
        StateMachine.skip();
    }

    private onKeyUpListener = (event: any) => {
        if (this.enabled && this.options && this.options.spaceToSpin) {
            if ((SpinControl.SPACE_TO_SKIP && event.keyCode === Keyboard.SPACE) || (SpinControl.ENTER_TO_SKIP && event.keyCode === Keyboard.ENTER)) {
                this.onButtonPressed();
            }
        }
    }
}
